export default {
  name: 'ServiceFiltersUrlGeneratingMixin',
  props: {
    basePath: {
      type: String,
      default: '',
    },
    baseMapPath: {
      type: String,
      default: '',
    },
    town: {
      type: String,
      default: '',
    },
    regionalCenter: {
      type: String,
      default: '',
    },
  },
  methods: {
    generateQueryString(filter) {
      const query = []

      if (!filter.sort.isDefault()) {
        query.push(`sort=${filter.sort.value}`)
      }

      return query.join('&')
    },
    generateUrlFromFilter(filter) {
      const query = this.generateQueryString(filter)
      let path = this.basePath

      path = path.replace('service-name', filter.service.value)

      const isTownRedirect = filter.region.type === 'station' && filter.region.data.townRedirectTranslit

      if (filter.region.data.regionType === 'station') {
        if (isTownRedirect) {
          path = path.replace('town-name', filter.region.data.townRedirectTranslit)
        } else {
          path = path.replace('town-name', this.regionalCenter)
        }
      } else {
        path = path.replace('town-name', this.town)
      }

      if (!filter.region.isDefault() && !isTownRedirect) {
        if (filter.region.data.regionType === 'district') {
          path += `d-${filter.region.value}/`
        }

        if (filter.region.data.regionType === 'station') {
          path += `metro-${filter.region.value}/`
        }
      } else if (!filter.region.isDefault()) {
        if (filter.region.data.regionType === 'district') {
          path = path.replace(/d-/g, '')
        }

        if (filter.region.data.regionType === 'station') {
          path = path.replace(/metro-/g, '')
        }
      }

      if (query) {
        return `${path}?${query}`
      }

      return path
    },
    generateMapUrl(filter) {
      const query = []

      if (this.town) {
        query.push(`town=${this.town}`)
      }

      if (filter.service) {
        query.push(`service=${filter.service.value}`)
      }

      if (!filter.region.isDefault()) {
        if (filter.region.data?.regionType === 'station') {
          query.push(`metro=${filter.region.value}`)
        }

        if (filter.region.data?.regionType === 'district') {
          query.push(`district=${filter.region.value}`)
        }
      }

      if (query.length) {
        return `${this.baseMapPath}?${query.join('&')}`
      }

      return this.baseMapPath
    },
  },
}
